{ "frames": {
   "0": {
    "frame": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "1": {
    "frame": { "x": 41, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "2": {
    "frame": { "x": 82, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "3": {
    "frame": { "x": 123, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "4": {
    "frame": { "x": 164, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "5": {
    "frame": { "x": 205, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "6": {
    "frame": { "x": 246, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "7": {
    "frame": { "x": 287, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "8": {
    "frame": { "x": 328, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "9": {
    "frame": { "x": 369, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "10": {
    "frame": { "x": 410, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "11": {
    "frame": { "x": 451, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "12": {
    "frame": { "x": 492, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "13": {
    "frame": { "x": 533, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "14": {
    "frame": { "x": 574, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "15": {
    "frame": { "x": 615, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "16": {
    "frame": { "x": 656, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "17": {
    "frame": { "x": 697, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "18": {
    "frame": { "x": 738, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "19": {
    "frame": { "x": 779, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   },
   "20": {
    "frame": { "x": 820, "y": 0, "w": 41, "h": 41 },
    "rotated": false,
    "trimmed": false,
    "spriteSourceSize": { "x": 0, "y": 0, "w": 41, "h": 41 },
    "sourceSize": { "w": 41, "h": 41 },
    "duration": 150
   }
 },
 "meta": {
  "app": "https://www.aseprite.org/",
  "version": "1.3.7-x64",
  "image": "Cabinet.png",
  "format": "RGBA8888",
  "size": { "w": 861, "h": 41 },
  "scale": "1",
  "frameTags": [
   { "name": "open", "from": 0, "to": 20, "direction": "forward", "color": "#000000ff" }
  ],
  "layers": [
   { "name": "Layer 1", "opacity": 255, "blendMode": "normal" }
  ],
  "slices": [
  ]
 }
}
